var _path, _path2, _path3, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadKlinkStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6339 0.871179C23.5677 0.332091 24.7181 0.332092 25.6518 0.87118L43.5423 11.2002C44.476 11.7393 45.0512 12.7356 45.0512 13.8138V34.4719C45.0512 35.5501 44.476 36.5464 43.5423 37.0855L25.6518 47.4145C24.7181 47.9536 23.5677 47.9536 22.6339 47.4145L4.74346 37.0855C3.80973 36.5464 3.23453 35.5501 3.23453 34.4719V13.8138C3.23453 12.7356 3.80973 11.7393 4.74346 11.2002L22.6339 0.871179Z",
    fill: "url(#paint0_linear_8467_89190)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6339 0.871179C23.5677 0.332091 24.7181 0.332092 25.6518 0.87118L43.5423 11.2002C44.476 11.7393 45.0512 12.7356 45.0512 13.8138V34.4719C45.0512 35.5501 44.476 36.5464 43.5423 37.0855L25.6518 47.4145C24.7181 47.9536 23.5677 47.9536 22.6339 47.4145L4.74346 37.0855C3.80973 36.5464 3.23453 35.5501 3.23453 34.4719V13.8138C3.23453 12.7356 3.80973 11.7393 4.74346 11.2002L22.6339 0.871179Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 19.7143L14.2857 14V28.2858L20 34.0001V28.5716L25.4285 34.0001H33.7142L26.8571 27.143H20V19.7143Z",
    fill: "#0F0F0F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2857,
    cy: 21.7146,
    r: 2.85714,
    fill: "#7660FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8467_89190",
    x1: 25.35,
    y1: -0.603572,
    x2: 3.01786,
    y2: 36.2143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478EDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F5C9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadKlinkStep1);
export default __webpack_public_path__ + "static/media/DownloadKlinkStep1.52e790dd87babc36c3f85c115b9e43e9.svg";
export { ForwardRef as ReactComponent };